// <head> metadata for PartnersPage (https://www.dbos.dev/partners).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Durable Workflow Orchestration Partners & Integrations | DBOS',
    },
    {
      name: 'description',
      content:
        'DBOS belongs to an ecosystem of AI and Cloud infrastructure technology and implementation services providers to help mutual customers build and and orchestrate durable workflows more easily and profitably.',
    },
    {
      property: 'og:title',
      content: 'Durable Workflow Orchestration Partners & Integrations | DBOS',
    },
    {
      property: 'og:description',
      content:
        'DBOS belongs to an ecosystem of AI and Cloud infrastructure technology and implementation services providers to help mutual customers build and and orchestrate durable workflows more easily and profitably.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Durable Workflow Orchestration Partners & Integrations | DBOS',
    },
    {
      name: 'twitter:description',
      content:
        'DBOS belongs to an ecosystem of AI and Cloud infrastructure technology and implementation services providers to help mutual customers build and and orchestrate durable workflows more easily and profitably.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/partners',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
